<template>
  <!-- 实训环境管理 列表页 -->
    <div class="board">
        <div v-hasPermi="['training:instance:list']">
            <div class="title">
                <span class="name">{{ trainingTextConfig.title }}</span>
            </div>
            <el-form :inline="true" :model="form" ref="form">
                <el-form-item>
                    <el-select v-model="form.addition_field.exam_plan" filterable clearable
                               :placeholder="searchTextConfig.examPlan">
                        <el-option v-for="(item, index) in examPlanOptions" :key="index" :label="item.name"
                                   :value="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="form.addition_field.admission_no" clearable
                              :placeholder="searchTextConfig.admission"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="form.training_mirror" clearable :placeholder="searchTextConfig.mirror">
                        <el-option v-for="item in trainingMirrorOptions" :key="item.label" :label="item.label"
                                   :value="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="form.status" clearable :placeholder="searchTextConfig.status">
                        <el-option v-for="item in statusOptions" :key="item.value" :label="item.label"
                                   :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search(1)">{{ searchTextConfig.select }}</el-button>
                    <el-button @click="reset">{{ searchTextConfig.reset }}</el-button>
                </el-form-item>
            </el-form>
            <p class="info">
                <span>已选：<i>{{ selectRow.length }}</i>/{{ tableData.length || 0 }} </span>
                <el-button v-hasPermi="['training:instance:add']" :disabled="!startRow.length"
                           @click="start([startRow],true)" type="success" size="mini" style="margin-left:10px">
                    {{ batchTextConfig.start.name }}
                </el-button>
                <el-button v-hasPermi="['training:instance:stop']" :disabled="!stopRow.length"
                           @click="stop([stopRow],true)" type="warning" size="mini">{{ batchTextConfig.stop.name }}
                </el-button>
                <el-button v-hasPermi="['training:instance:delete']" :disabled="!deleteRow.length"
                           @click="delet([deleteRow],true)" type="danger" size="mini">{{ batchTextConfig.remove.name }}
                </el-button>
            </p>
            <el-table :data="tableData" v-loading="loading" element-loading-text="加载中"
                      element-loading-spinner="el-icon-loading" ref="multipleTable"
                      @selection-change="handleSelectionChange" stripe size="medium" :height="height"
                      style="width:100%">
                <el-table-column type="selection" width="48" fixed="left" align="center"
                                 :selectable="checkSelectable"></el-table-column>
                <el-table-column prop="addition_field.exam_plan" :label="tableTextConfig.examPlan" min-width="140px"
                                 show-overflow-tooltip></el-table-column>
<!--                <el-table-column prop="addition_field.examinee_no" :label="tableTextConfig.examineeNo" min-width="140px"-->
<!--                                 show-overflow-tooltip></el-table-column>-->
                <el-table-column prop="addition_field.examinee_name" :label="tableTextConfig.examineeName"
                                 min-width="120px"></el-table-column>
                <el-table-column prop="addition_field.admission_no" :label="tableTextConfig.admissionNo"
                                 min-width="140px"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="training_mirror" :label="tableTextConfig.mirror"
                                 :min-width="flexColumnWidth('training_mirror',4,tableData)"></el-table-column>
                <el-table-column prop="last_start_time" :label="tableTextConfig.startTime" min-width="160px">
                    <template slot-scope="scope">{{ scope.row.last_start_time | formatTime }}</template>
                </el-table-column>
                <el-table-column prop="exam_type" :label="tableTextConfig.runningTime" min-width="120px">
                    <template slot-scope="scope">{{ filterTime(scope.row.last_running_time * 1) }}</template>
                </el-table-column>
                <el-table-column :label="tableTextConfig.cumulativeNum" min-width="150px">
                    <template slot-scope="scope"><span
                            class="spaceBetween">{{
                        filterTime(scope.row.cumulative_num * 1 === 1 ? scope.row.last_running_time * 1 : (scope.row.cumulative_time * 1 + scope.row.last_running_time * 1))
                        }}<span>{{ scope.row.cumulative_num }}次</span></span>
                    </template>
                </el-table-column>
                <el-table-column :label="tableTextConfig.status" min-width="80px">
                    <template slot-scope="scope">
                        <el-tag :type="getTagType(scope.row.status)">{{ scope.row.status_label }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" :label="tableTextConfig.operate" min-width="285px">
                    <template slot-scope="scope">
                        <el-button v-hasPermi="['training:instance:add']" plain type="success" size="mini"
                                   v-if="scope.row.status === 'STOPED'" @click="start([scope.row.id])">
                            {{ tableButtonTextConfig.start.name }}
                        </el-button>
                        <el-button v-hasPermi="['training:instance:stop']" plain type="warning" size="mini"
                                   v-if="scope.row.status === 'CREATING' || scope.row.status === 'RUNNING'"
                                   @click="stop([scope.row.id])">
                            {{ tableButtonTextConfig.stop.name }}
                        </el-button>
                        <el-button v-hasPermi="['training:instance:delete']" plain type="danger" size="mini"
                                   v-if="scope.row.status !== 'TERMINATING'" @click="delet([scope.row.id])">
                            {{ tableButtonTextConfig.remove.name }}
                        </el-button>
                        <el-button plain type="primary" size="mini" @click="copy(scope.row.namespace)">
                            {{ tableButtonTextConfig.copy.name }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagination v-show="tableData.length" :currentPage.sync="form.page_number" :pageSize.sync="form.page_size"
                        :total.sync="total"></pagination>
        </div>
    </div>
</template>

<script>
import pagination from '@/components/pagination/pagination.vue'

export default {
    components: {
        pagination
    },
    data() {
        return {
            height: 250,
            loading: true,
            form: {
                addition_field: {
                    exam_plan: '', // 考试计划
                    admission_no: '', // 准考证号
                },
                training_mirror: '', // 实训镜像环境
                status: '', // 实训状态
                page_number: 1,
                page_size: 20
            },
            total: 0,
            trainingMirrorOptions: [],
            examPlanOptions: [],
            statusOptions: [
                {
                    value: 'CREATING',
                    label: this.$store.state.global.textConfig.backend.training.statusEnum.creating,
                    type: 'primary'
                },
                {
                    value: 'RUNNING',
                    label: this.$store.state.global.textConfig.backend.training.statusEnum.running,
                    type: 'success'
                },
                {
                    value: 'STOPPING',
                    label: this.$store.state.global.textConfig.backend.training.statusEnum.stopping,
                    type: 'warning'
                },
                {
                    value: 'STOPED',
                    label: this.$store.state.global.textConfig.backend.training.statusEnum.stoped,
                    type: 'warning'
                },
                {
                    value: 'TERMINATING',
                    label: this.$store.state.global.textConfig.backend.training.statusEnum.terminating,
                    type: 'danger'
                },
            ],
            tableData: [],
            row: null,
            selectRow: [],
            startRow: [],
            stopRow: [],
            deleteRow: [],
        }
    },
    computed: {
        trainingEnable() {
            return this.$store.state.global.textConfig.training.enable
        },
        trainingTextConfig() {
            return this.$store.state.global.textConfig.backend.training
        },
        searchTextConfig() {
            return this.trainingTextConfig.search
        },
        batchTextConfig() {
            return this.trainingTextConfig.batch
        },
        tableTextConfig() {
            return this.trainingTextConfig.table
        },
        tableButtonTextConfig() {
            return this.tableTextConfig.button
        },
    },
    watch: {
        tableData() {
            if (this.tableData.length == 0) {
                this.height = 120
            } else {
                this.updateHeight()
            }
        }
    },
    methods: {
        checkSelectable(row) {
            return row.status !== 'TERMINATING'
        },
        filterTime(endTime) {
            if (endTime < 0) {
                return '-- : -- : --'
            } else if (endTime === 0) {
                return '-- : -- : --'
            } else {
                let secondTime = parseInt(endTime)//将传入的秒的值转化为Number
                let min = 0// 初始化分
                let h = 0// 初始化小时
                let result = ''
                if (secondTime > 60) {//如果秒数大于60，将秒数转换成整数
                    min = parseInt(secondTime / 60)//获取分钟，除以60取整数，得到整数分钟
                    secondTime = parseInt(secondTime % 60)//获取秒数，秒数取佘，得到整数秒数
                    if (min > 60) {//如果分钟大于60，将分钟转换成小时
                        h = parseInt(min / 60)//获取小时，获取分钟除以60，得到整数小时
                        min = parseInt(min % 60) //获取小时后取佘的分，获取分钟除以60取佘的分
                    }
                }
                result = `${h.toString().padStart(2, '0')} : ${min.toString().padStart(2, '0')} : ${secondTime.toString().padStart(2, '0')}`
                return result
            }
        },
        getTagType(val) {
            for (let i = 0; i < this.statusOptions.length; i++) {
                const e = this.statusOptions[i];
                if (e.value === val) {
                    return e.type
                }
            }
        },
        handleSelectionChange(val) {
            this.selectRow = val
            for (let i = 0; i < val.length; i++) {
                const e = val[i];
                console.log('e', e);
                if (e.status === "STOPED") {
                    this.startRow.push(e.id)
                } else if (e.status === "CREATING" || e.status === "RUNNING") {
                    this.stopRow.push(e.id)
                }
                if (e.status !== "TERMINATING") {
                    this.deleteRow.push(e.id)
                }
            }
        },
        search(val) {
            this.loading = true
            if (val) {
                this.form.page_number = val
            }
            let form = JSON.parse(JSON.stringify(this.form))
            form.addition_field = JSON.stringify(this.form.addition_field)
            this.$store.dispatch("getTrainingList", form).then(res => {
                if (res.status == 200) {
                    this.tableData = res.data.list
                    this.total = res.data.total
                }
                this.loading = false
                this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
            }).catch(err => {
                console.log(err);
                this.loading = false
            })
        },
        reset() {
            this.form = {
                addition_field: {
                    exam_plan: '', // 考试计划
                    admission_no: '', // 准考证号
                },
                training_mirror: '', // 实训镜像环境
                status: '', // 实训状态
                page_number: 1,
                page_size: 20
            }
            this.form.page_size = 20
            this.search(1)
        },
        start(id, bool) {
            let title = bool ? this.batchTextConfig.start.title : this.tableButtonTextConfig.start.title
            let message = bool ? this.batchTextConfig.start.message : this.tableButtonTextConfig.start.message
            let startTextConfig = this.tableButtonTextConfig.start
            this.$confirm(message, title, {
                confirmButtonText: startTextConfig.ok,
                cancelButtonText: startTextConfig.cancel,
                type: 'warning'
            }).then(() => {
                this.$store.dispatch("postTrainingInstances", id.join(',')).then(res => {
                    this.$message({
                        type: 'success',
                        message: startTextConfig.success
                    });
                    this.search(1)
                });
            })
        },
        stop(id, bool) {
            let title = bool ? this.batchTextConfig.stop.title : this.tableButtonTextConfig.stop.title
            let message = bool ? this.batchTextConfig.stop.message : this.tableButtonTextConfig.stop.message
            let stopTextConfig = this.tableButtonTextConfig.stop
            this.$confirm(message, title, {
                confirmButtonText: stopTextConfig.ok,
                cancelButtonText: stopTextConfig.cancel,
                type: 'warning'
            }).then(() => {
                this.$store.dispatch("putTrainingInstances", id.join(',')).then(res => {
                    this.$message({
                        type: 'success',
                        message: stopTextConfig.success
                    });
                    this.search(1)
                });
            })
        },
        delet(id, bool) {
            let title = bool ? this.batchTextConfig.remove.title : this.tableButtonTextConfig.remove.title
            let message = bool ? this.batchTextConfig.remove.message : this.tableButtonTextConfig.remove.message
            let removeTextConfig = this.tableButtonTextConfig.remove
            this.$confirm(message, title, {
                confirmButtonText: removeTextConfig.ok,
                cancelButtonText: removeTextConfig.cancel,
                type: 'warning'
            }).then(() => {
                this.$store.dispatch("deleteTrainingInstances", id.join(',')).then(res => {
                    this.$message({
                        type: 'success',
                        message: removeTextConfig.success
                    });
                    if (this.tableData.length == 1) {
                        let num = this.form.page_number == 1 ? 1 : this.form.page_number - 1
                        this.search(num)
                    } else {
                        this.search()
                    }
                })
            })
        },
        copy(str) {
            const el = document.createElement('textarea');
            el.value = str;
            el.setAttribute('readonly', '');
            el.style.position = 'absolute';
            el.style.left = '-9999px';
            document.body.appendChild(el);
            const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
            if (selected) {
                document.getSelection().removeAllRanges();
                document.getSelection().addRange(selected);
            }
            this.$message({type: 'success', message: this.tableButtonTextConfig.copy.success});
        },
        updateHeight() {
            if (document.getElementsByClassName('el-form')[0]) {
                this.height = document.getElementsByClassName('board')[0].clientHeight - document.getElementsByClassName('el-form')[0].clientHeight - 190
                this.height = this.height < 460 ? 460 : this.height
            }
        }
    },
    created() {
        this.$store.dispatch("getExamPlan").then(res => {
            this.examPlanOptions = res.data
        });
        if (this.trainingEnable) {
            this.$store.dispatch("getTrainingMirrorList").then(res => {
                this.trainingMirrorOptions = res.data
            });
        }
        this.search(1)
    },
    mounted() {
        const that = this;
        setTimeout(() => {
            that.updateHeight()
        }, 200);
        window.onresize = () => {
            that.updateHeight()
        };
    },
}
</script>

<style scoped>
.info {
    color: #555;
    font-size: 15px;
    margin-bottom: 12px;
}

.info span {
    color: #C0C4CC;
    margin-left: 12px;
}

.info i {
    color: #555;
}

.spaceBetween {
    display: flex;
    justify-content: space-between;
}
</style>